import * as bootstrap from "bootstrap";
import {
  getElementMargins,
  getElementPaddings,
  hide,
  unhide,
} from "../../utils";
import { EventBus, Events } from "../eventBus";
import {
  ANCHOR_COLOUR,
  ANCHORS,
  getAnchorDefaultDimensions,
  isSizeBasedAnchor,
  makeAnchorImage,
  makeAnchorPreviewElement,
} from "./anchors";
import { CSSClass, ElemID } from "./constants";

const pageContainer = document.getElementById(ElemID.EDITOR_PAGE_CONTAINER);
const pageContainerWrapper = document.getElementById(
  ElemID.EDITOR_PAGE_CONTAINER_WRAPPER,
);
const previewPageContainer = document.getElementById(
  ElemID.PREVIEW_PAGE_CONTAINER,
);
const previewPageContainerWrapper = document.getElementById(
  ElemID.PREVIEW_PAGE_CONTAINER_WRAPPER,
);
const editorThumbnailContainer = document.getElementById(
  ElemID.EDITOR_THUMBNAIL_CONTAINER,
);
const previewThumbnailContainer = document.getElementById(
  ElemID.PREVIEW_THUMBNAIL_CONTAINER,
);

// emit click events
pageContainerWrapper.addEventListener("click", function () {
  EventBus.emit(Events.PAGE_CONTAINER_CLICKED);
});

export function renderAnchorMenu() {
  const requesterFieldContainer = document.getElementById("requester-fields");
  ANCHORS.requester.main.forEach(function (anchorData) {
    renderStaticAnchor(requesterFieldContainer, anchorData, "requester");
  });
  const requesterFieldMoreContainer = document.getElementById(
    "requester-fields-more",
  );
  ANCHORS.requester.more.forEach(function (anchorData) {
    renderStaticAnchor(requesterFieldMoreContainer, anchorData, "requester");
  });

  const signerFieldContainer = document.getElementById("signer-fields");
  ANCHORS.signer.main.forEach(function (anchorData) {
    renderStaticAnchor(signerFieldContainer, anchorData, "signer");
  });
  const signerFieldMoreContainer =
    document.getElementById("signer-fields-more");
  ANCHORS.signer.more.forEach(function (anchorData) {
    renderStaticAnchor(signerFieldMoreContainer, anchorData, "signer");
  });

  const metadataFieldContainer = document.getElementById("metadata-fields");
  ANCHORS["signature request"].main.forEach(function (anchorData) {
    renderStaticAnchor(metadataFieldContainer, anchorData, "signature request");
  });
  const metadataFieldMoreContainer = document.getElementById(
    "metadata-fields-more",
  );
  ANCHORS["signature request"].more.forEach(function (anchorData) {
    renderStaticAnchor(
      metadataFieldMoreContainer,
      anchorData,
      "signature request",
    );
  });
}

function renderStaticAnchor(parentElem, data, category) {
  const anchor = document.createElement("div");
  anchor.classList.add(CSSClass.STATIC_ANCHOR);
  anchor.style.borderLeft = `5px solid ${ANCHOR_COLOUR.bg[category]}`;

  anchor.innerHTML = `<i class="bi ${data.icon}"></i> ${data.label}`;

  // store anchor data to be used by renderFloatingAnchor
  anchor.dataset.anchor = data.anchor;
  anchor.dataset.unscaledWidth = data.width;
  anchor.dataset.unscaledHeight = data.height;
  anchor.dataset.anchorText = data.anchorText;
  anchor.dataset.description = data.description;
  if (isSizeBasedAnchor(data.anchor)) {
    anchor.dataset.resizable = "true";
  }

  // store category so we know how to style the floating anchor
  anchor.dataset.category = category;

  parentElem.appendChild(anchor);
}

export function renderFloatingAnchor(staticAnchor, mouseX, mouseY, scale) {
  /**
   * Creates a floating anchor based on data from a static anchor, and place it such that the mouse is
   * right in the middle of the floating anchor.
   */
  const width = Number(staticAnchor.dataset.unscaledWidth);
  const height = Number(staticAnchor.dataset.unscaledHeight);
  const scaledWidth = width * scale;
  const scaledHeight = height * scale;
  const anchor = staticAnchor.dataset.anchor;
  const category = staticAnchor.dataset.category;
  const anchorText = staticAnchor.dataset.anchorText;
  const description = staticAnchor.dataset.description;
  const resizable = staticAnchor.dataset.resizable === "true";
  const id = ElemID.ANCHOR_PREFIX + Date.now();

  const element = document.createElement("div");
  // element.textContent = anchor;
  element.setAttribute("id", id);

  // apply CSS classes
  element.classList.add(CSSClass.FLOATING_ANCHOR);
  element.classList.add(
    resizable ? CSSClass.RESIZABLE_MOVABLE_ANCHOR : CSSClass.MOVABLE_ANCHOR,
  );

  // position it so it is directly under the mouse.
  element.style.position = "absolute";
  element.style.left = mouseX - scaledWidth / 2 + "px";
  element.style.top = mouseY - scaledHeight / 2 + "px";
  // element.style.display = "flex";
  element.style.width = scaledWidth + "px";
  element.style.height = scaledHeight + "px";

  const img = document.createElement("img");
  img.setAttribute("src", makeAnchorImage(anchor));
  img.setAttribute("alt", anchorText);
  img.style.width = "100%";
  img.style.height = "100%";
  img.style.maxWidth = "100%";
  img.style.maxHeight = "100%";
  img.setAttribute("draggable", "false"); // make image not draggable or it might move without div
  element.appendChild(img);

  // Inject resize handles
  if (resizable) {
    function makeResizeHandle(verticalEdge, horizontalEdge) {
      // verticalEdge must be "top" or "bottom"
      // horizontalEdge must be "left" or "right"
      const handle = document.createElement("div");
      handle.classList.add("anchor-resize-handle");
      handle.classList.add(`resize-${verticalEdge}`);
      handle.classList.add(`resize-${horizontalEdge}`);
      handle.style[verticalEdge] = "-4px";
      handle.style[horizontalEdge] = "-4px";
      return handle;
    }

    element.appendChild(makeResizeHandle("top", "left"));
    element.appendChild(makeResizeHandle("top", "right"));
    element.appendChild(makeResizeHandle("bottom", "left"));
    element.appendChild(makeResizeHandle("bottom", "right"));
    element.dataset.resizable = "yes"; // this value drive
  }

  // store more metadata
  element.dataset.id = id;
  element.dataset.anchor = anchor;
  element.dataset.anchorText = anchorText;
  element.dataset.category = category;
  element.dataset.description = description;
  element.dataset.unscaledWidth = staticAnchor.dataset.unscaledWidth;
  element.dataset.unscaledHeight = staticAnchor.dataset.unscaledHeight;

  // add element to document
  document.getElementById(ElemID.DOCUMENT).appendChild(element);

  // emit click events
  element.addEventListener("click", function (event) {
    event.stopPropagation();
    EventBus.emit(Events.ANCHOR_CLICKED, { anchorId: id });
  });

  return element;
}

export function findAnchorsInPageDiv(pageNumber) {
  const anchors = [];
  const pageDiv = document.getElementById(ElemID.PAGE_PREFIX + pageNumber);
  const scale = Number(pageDiv.dataset.scale);
  if (!pageDiv) {
    console.error(`Could not locate div for page ${pageNumber}`);
  } else {
    pageDiv
      .querySelectorAll("." + CSSClass.FLOATING_ANCHOR)
      .forEach(function (anchorElement) {
        let unscaled = getAnchorUnscaledDimensions(anchorElement, scale);
        anchors.push({
          anchor: anchorElement.dataset.anchor,
          anchorText: anchorElement.dataset.anchorText,
          description: anchorElement.dataset.description,
          scale: scale, // current scale in main editor
          id: anchorElement.id,
          page: Number(pageNumber),
          // these are UNSCALED values
          x: Math.max(0, Number(anchorElement.dataset.deltaX || "0")) / scale,
          y: Math.max(0, Number(anchorElement.dataset.deltaY || "0")) / scale,
          width: unscaled.width,
          height: unscaled.height,
        });
      });
  }

  return anchors;
}

function getAnchorUnscaledDimensions(anchorElement, scale) {
  const anchorName = anchorElement.dataset.anchor;
  if (isSizeBasedAnchor(anchorName)) {
    // user resizable, so we infer size from element itself
    const elementStyle = window.getComputedStyle(anchorElement);
    const scaledWidth = parseInt(elementStyle.width);
    const scaledHeight = parseInt(elementStyle.height);
    return {
      width: scaledWidth / scale,
      height: scaledHeight / scale,
    };
  } else {
    // use default sizes
    return getAnchorDefaultDimensions(anchorName);
  }
}

export async function initialPageRender(
  pdfPage,
  pageNum,
  scale,
  isPreview = false,
) {
  const commonPrefix = isPreview ? ElemID.PREVIEW_PREFIX : "";

  // first create the page div that will hold the page canvas and anchor nodes
  const pageDiv = document.createElement("div");
  pageDiv.setAttribute("id", commonPrefix + ElemID.PAGE_PREFIX + pageNum);
  pageDiv.classList.add(CSSClass.PAGE);
  pageDiv.classList.add("shadow"); // bootstrap util class
  // Store page number in data attr for easy lookup
  pageDiv.dataset.pageNumber = String(pageNum);
  // Store the scale the page is currently rendered with to assign with rescaling anchor positions later
  pageDiv.dataset.scale = String(scale);

  // add to container
  (isPreview ? previewPageContainer : pageContainer).appendChild(pageDiv);

  // next create the canvas that will hold the PDF page
  const canvas = document.createElement("canvas");
  canvas.setAttribute("id", commonPrefix + ElemID.CANVAS_PREFIX + pageNum);
  canvas.classList.add(CSSClass.PAGE_CANVAS);
  pageDiv.appendChild(canvas);

  // capture the 1:1 page dimensions. This allows us to later rescale page elements before re-rendering PDF
  const unscaledViewport = pdfPage.getViewport({ scale: 1.0 });
  pageDiv.dataset.unscaledWidth = String(unscaledViewport.width);
  pageDiv.dataset.unscaledHeight = String(unscaledViewport.height);

  // rescale page containers
  rescalePageContainer(pageNum, scale, isPreview);

  // render the pdf page
  await renderPage(pdfPage, pageNum, scale, isPreview);

  return {
    unscaledWidth: unscaledViewport.width,
    unscaledHeight: unscaledViewport.height,
    pageCanvas: canvas,
  };
}

export function resetPreviewThumbnail() {
  previewThumbnailContainer.scrollTop = 0;
}

export async function renderThumbnail(thumbnail, pageNum, isPreview = false) {
  const container = isPreview
    ? previewPageContainerWrapper
    : pageContainerWrapper;
  const thumbContainer = isPreview
    ? previewThumbnailContainer
    : editorThumbnailContainer;
  const commonPrefix = isPreview ? ElemID.PREVIEW_PREFIX : "";
  const thumbDiv = document.createElement("div");
  const footerHeight = 20;
  thumbDiv.setAttribute("id", commonPrefix + ElemID.THUMBNAIL_PREFIX + pageNum);
  thumbDiv.classList.add(CSSClass.THUMBNAIL);
  thumbDiv.style.width = thumbnail.width + "px";
  thumbDiv.style.height = thumbnail.height + footerHeight + "px";
  thumbContainer.appendChild(thumbDiv);

  // navigate to page on click
  thumbDiv.addEventListener("click", function () {
    const page = document.getElementById(
      commonPrefix + ElemID.PAGE_PREFIX + pageNum,
    );
    container.scrollTop =
      page.offsetTop - container.getBoundingClientRect().top;
  });

  // add thumbnail image
  const image = document.createElement("img");
  image.src = thumbnail.src;
  image.style.width = "100%";
  thumbDiv.appendChild(image);

  // add thumbnail footer with page number
  const footer = document.createElement("div");
  footer.textContent = "Page " + pageNum;
  footer.classList.add("thumbnail-footer");
  footer.style.height = footerHeight + "px";
  thumbDiv.appendChild(footer);

  // add indicator tab container
  const tabBar = document.createElement("div");
  tabBar.setAttribute(
    "id",
    commonPrefix + ElemID.THUMBNAIL_TAB_PREFIX + pageNum,
  );
  tabBar.classList.add("thumbnail-tab-bar");
  thumbDiv.appendChild(tabBar);

  // For now, pre-define tabs for all possible anchor categories
  addAnchorTabToThumbnail(tabBar, "signer");
  addAnchorTabToThumbnail(tabBar, "requester");
  addAnchorTabToThumbnail(tabBar, "signature request");
}

const ANCHOR_TAB_CSS_CLASSES = {
  requester: "thumbnail-anchor-tab-requester",
  signer: "thumbnail-anchor-tab-signer",
  "signature request": "thumbnail-anchor-tab-signature-request",
};

function addAnchorTabToThumbnail(tabBarElement, category) {
  const cssClass = ANCHOR_TAB_CSS_CLASSES[category];
  const tab = document.createElement("div");
  tab.classList.add("d-none");
  tab.classList.add("thumbnail-anchor-tab");
  tab.classList.add(cssClass);
  tabBarElement.appendChild(tab);
}

export function showAnchorTabOnThumbnail(pageNum, category, isPreview) {
  const commonPrefix = isPreview ? ElemID.PREVIEW_PREFIX : "";
  const tab = document.getElementById(
    commonPrefix + ElemID.THUMBNAIL_TAB_PREFIX + pageNum,
  );
  unhide(tab.querySelector("." + ANCHOR_TAB_CSS_CLASSES[category]));
}

export function hideAnchorTabOnThumbnail(pageNum, category, isPreview) {
  const commonPrefix = isPreview ? ElemID.PREVIEW_PREFIX : "";
  const tab = document.getElementById(
    commonPrefix + ElemID.THUMBNAIL_TAB_PREFIX + pageNum,
  );
  hide(tab.querySelector("." + ANCHOR_TAB_CSS_CLASSES[category]));
}

EventBus.subscribe(Events.PAGE_IN_VIEW, function (payload) {
  const isPreview = payload.screen === "preview";
  const thumbnailContainer = isPreview
    ? previewThumbnailContainer
    : editorThumbnailContainer;
  const commonPrefix = isPreview ? ElemID.PREVIEW_PREFIX : "";
  thumbnailContainer
    .querySelectorAll(".thumbnail-active-page")
    .forEach(function (element) {
      element.classList.remove("thumbnail-active-page");
    });

  const thumbDiv = document.getElementById(
    commonPrefix + ElemID.THUMBNAIL_PREFIX + payload.page,
  );
  thumbDiv.classList.add("thumbnail-active-page");
});

export async function renderPage(page, pageNum, scale, isPreview = false) {
  console.debug(`Rendering ${isPreview ? "preview" : "page"} ${pageNum}`);
  const commonPrefix = isPreview ? ElemID.PREVIEW_PREFIX : "";

  const viewport = page.getViewport({ scale: scale });
  // Support HiDPI-screens.
  const outputScale = window.devicePixelRatio || 1;

  const canvas = document.getElementById(
    commonPrefix + ElemID.CANVAS_PREFIX + pageNum,
  );
  const context = canvas.getContext("2d");

  // Prepare canvas using PDF page dimensions
  // N.B. canvas.width != canvas.style.width (as with height)
  canvas.width = Math.floor(viewport.width * outputScale);
  canvas.height = Math.floor(viewport.height * outputScale);

  const transform =
    outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : null;

  // Render PDF page into canvas context
  const renderContext = {
    canvasContext: context,
    transform: transform,
    viewport: viewport,
  };

  // TODO: cancellable task (return cancel func?)

  await page.render(renderContext).promise;
}

export function fitDocumentContainerAroundPages(
  unscaledWidth,
  scale,
  isPreview = false,
) {
  const container = isPreview ? previewPageContainer : pageContainer;
  // get first page to extract margins
  const commonPrefix = isPreview ? ElemID.PREVIEW_PREFIX : "";
  const page = document.getElementById(commonPrefix + ElemID.PAGE_PREFIX + "1");
  let margins, paddings;
  try {
    // this could fail if func is triggered after preview is hidden.
    margins = getElementMargins(page);
    paddings = getElementPaddings(pageContainer);
  } catch (e) {
    return;
  }
  const width =
    unscaledWidth * scale +
    margins.left +
    margins.right +
    paddings.left +
    paddings.right;
  container.style.width = width + "px";
  container.style.minWidth = width + "px";
}

export function getCurrentScale(isPreview) {
  const commonPrefix = isPreview ? ElemID.PREVIEW_PREFIX : "";
  const pageDiv = document.getElementById(
    commonPrefix + ElemID.PAGE_PREFIX + 1,
  );
  return Number(pageDiv.dataset.scale);
}

export function rescalePageContainer(pageNum, scale, isPreview = false) {
  const commonPrefix = isPreview ? ElemID.PREVIEW_PREFIX : "";
  const pageDiv = document.getElementById(
    commonPrefix + ElemID.PAGE_PREFIX + pageNum,
  );
  const previousScale = Number(pageDiv.dataset.scale);
  pageDiv.dataset.scale = String(scale); // Update stored scale on page
  const unscaledHeight = Number(pageDiv.dataset.unscaledHeight);
  const unscaledWidth = Number(pageDiv.dataset.unscaledWidth);
  const width = unscaledWidth * scale;
  const height = unscaledHeight * scale;
  pageDiv.style.width = width + "px";
  pageDiv.style.height = height + "px";

  const canvas = document.getElementById(
    commonPrefix + ElemID.CANVAS_PREFIX + pageNum,
  );
  canvas.style.width = width + "px";
  canvas.style.height = height + "px";

  // We also need to rescale the size and translation of each attached anchors
  const anchorClass = isPreview
    ? CSSClass.PREVIEW_ANCHOR
    : CSSClass.FLOATING_ANCHOR;

  pageDiv.querySelectorAll("." + anchorClass).forEach(function (anchorElement) {
    // rescale sizes
    let anchorUnscaledWidth = anchorElement.dataset.unscaledWidth;
    let anchorUnscaledHeight = anchorElement.dataset.unscaledHeight;
    if (anchorElement.dataset.resizable === "yes") {
      let anchorStyle = window.getComputedStyle(anchorElement);
      anchorUnscaledWidth = parseInt(anchorStyle.width, 10) / previousScale;
      anchorUnscaledHeight = parseInt(anchorStyle.height, 10) / previousScale;
    }
    anchorElement.style.width = String(anchorUnscaledWidth * scale) + "px";
    anchorElement.style.height = String(anchorUnscaledHeight * scale) + "px";

    // rescale translation
    const deltaX =
      (Number(anchorElement.dataset.deltaX) / previousScale) * scale;
    const deltaY =
      (Number(anchorElement.dataset.deltaY) / previousScale) * scale;
    anchorElement.dataset.deltaX = String(deltaX);
    anchorElement.dataset.deltaY = String(deltaY);
    anchorElement.style.transform = `translate(${deltaX}px, ${deltaY}px)`;
  });
}

export function destroyPreview() {
  if (previewPageContainer.replaceChildren) {
    previewPageContainer.replaceChildren();
  } else {
    previewPageContainer.innerHTML = "";
  }
}

export function freePreviewCanvases() {
  previewPageContainer
    .querySelectorAll("." + CSSClass.PAGE_CANVAS)
    .forEach(function (canvas) {
      // free mem
      canvas.width = 0;
      canvas.height = 0;
      canvas.remove();
    });
}

export function renderAnchorPreview(anchor, pageNum, scale, targetDiv) {
  const elem = makeAnchorPreviewElement(
    anchor.anchor,
    anchor.width,
    anchor.height,
  );
  const relativeX = anchor.x * scale;
  const relativeY = anchor.y * scale;
  const scaledWidth = anchor.width * scale;
  const scaledHeight = anchor.height * scale;
  const pageDiv =
    targetDiv ||
    document.getElementById(
      ElemID.PREVIEW_PREFIX + ElemID.PAGE_PREFIX + pageNum,
    );
  if (!pageDiv) {
    // if preview hidden immediately before this func is called, page div might have been removed
    return;
  }

  // Apply same positioning mechanism and metadata as floating anchors so we can use same logic for zoom
  elem.classList.add(CSSClass.PREVIEW_ANCHOR);
  elem.style.position = "absolute";
  elem.style.cursor = "default";
  elem.style.top = "0px";
  elem.style.left = "0px";
  elem.style.width = scaledWidth + "px";
  elem.style.height = scaledHeight + "px";
  elem.style.transform = `translate(${relativeX}px, ${relativeY}px)`;
  elem.dataset.deltaX = String(relativeX);
  elem.dataset.deltaY = String(relativeY);
  elem.dataset.unscaledWidth = anchor.width;
  elem.dataset.unscaledHeight = anchor.height;

  pageDiv.appendChild(elem);

  new bootstrap.Tooltip(elem, {
    title: anchor.description,
  });
}
